import axios from 'axios'

export const isBrowser = () => typeof window !== 'undefined'

export const getUser = () =>
	isBrowser() && window.localStorage.getItem('gatsbyUser') ? JSON.parse(window.localStorage.getItem('gatsbyUser')) : {}

const setUser = (user) => window.localStorage.setItem('gatsbyUser', JSON.stringify(user))

export const handleLogin = ({ email, password }, callback, errorFunction) => {
	axios
		.post(`${process.env.GATSBY_API_URL}/auth/local`, {
			identifier: email,
			password: password
		})
		.then((response) => {
			axios
				.get(
					`${process.env.GATSBY_API_URL}/users/${response.data.user.id}?populate=role,Cv,Profilepicture,Careers,Jobtypes,Salaryrange,Disability,Education,Education.Qualification,Workexperience,Userskill,Usercareer,Userskill.Skill,Usercareer.Career`,
					{
						headers: { Authorization: 'Bearer ' + response.data.jwt }
					}
				)
				.then((resp) => {
					setUser({
						user: {
							...resp.data,
							Careers: resp.data.Careers?.map(({ id }) => id),
							Jobtypes: resp.data.Jobtypes?.map(({ id }) => id)
						},
						token: response.data.jwt
					})
					callback(resp.data.role)
				})
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			errorFunction()
		})
}

export const handleSocialLogin = (
	{ provider, search },
	callback,
	errorFunction
  ) => {
  
	axios
	  .get(`${process.env.GATSBY_API_URL}/auth/${provider}/callback${search}`)
	  .then(response => {
		axios
		.get(
		  `${process.env.GATSBY_API_URL}/users/${response.data.user.id}?populate=role,Cv,Profilepicture,Careers,Jobtypes,Salaryrange,Disability,Education,Workexperience,Userskill,Usercareer,Userskill.Skill,Usercareer.Career`,
		  {
			headers: { Authorization: "Bearer " + response.data.jwt },
		  }
		)
		.then(resp => {
		  // Handle success.
		  // console.log('Well done!');
		  // console.log('User profile', response.data.user);
		  // console.log('User token', response.data.jwt);
		  setUser({
			user: {
			  ...resp.data,
			 careers: response.data.user.Careers?.map(({ id }) => id),
			},
			token: response.data.jwt,
		  })
		  callback(resp.data.role)
		})
	  })
	  .catch(error => {
		console.log("An error occurred:", error)
		// return false
		errorFunction()
	  })
}

export const isLoggedIn = () => {
	const user = getUser()
	return !!user.token
}

export const logout = (callback) => {
	setUser({})
	callback()
}

export const handleRegister = (
	{ firstname, lastname, gender, email, password, telno, accepttc, careers },
	callback,
	errorFunction
) => {
	axios
		.post(`${process.env.GATSBY_API_URL}/auth/local/register`, {
			Firstname: firstname,
			Lastname: lastname,
			Gender: gender,
			username: email,
			email,
			password,
			Telno: telno,
			Acceptterms: accepttc,
			Careers: careers
		})
		.then((response) => {
			callback()
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
			errorFunction(error.response.data.message[0].messages[0])
		})
}

export const handleForgot = ({ email }, callback, errorFunction) => {
	axios
		.post(`${process.env.GATSBY_API_URL}/auth/forgot-password`, {
			email
		})
		.then((response) => {
			callback()
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
			errorFunction(error.response.data.message[0].messages[0])
		})
}

export const handleReset = ({ code, password, passwordConfirmation }, callback, errorFunction) => {
	axios
		.post(`${process.env.GATSBY_API_URL}/auth/reset-password`, {
			code,
			password,
			passwordConfirmation
		})
		.then((response) => {
			callback()
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
			errorFunction(error.response.data.message[0].messages[0])
		})
}

export const updateUserProfile = (
	{
		id,
		Firstname,
		Lastname,
		Gender,
		Telno,
		Careers,
		Jobtypes,
		Birthdate,
		Street,
		Housenumber,
		City,
		Religion,
		Employmentstatus,
		Salaryrange,
		Facebookprofile,
		Linkedinprofile,
		Homeprovince,
		Disability,
		Suburb,
		Description,
		Education,
		Workexperience,
		Userskill,
		Usercareer
	},
	callback,
	errorFunction
) => {
	const token = getUser().token
	const career_1 = Careers[0]
	const career_2 = Careers[1]
	const career_3 = Careers[2]

	axios
		.put(
			`${process.env.GATSBY_API_URL}/users/${id}`,
			{
				Firstname,
				Lastname,
				Gender,
				Telno,
				Careers,
				Jobtypes,
				Birthdate,
				Street,
				Housenumber,
				City,
				Religion,
				Employmentstatus,
				Salaryrange,
				Facebookprofile,
				Linkedinprofile,
				Homeprovince,
				Disability,
				Description,
				Education,
				Workexperience,
				Userskill,
				Usercareer,
				Suburb,
				career_1,
				career_2,
				career_3
			},
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		)
		.then((response) => {
			axios
				.get(
					`${process.env.GATSBY_API_URL}/users/${id}?populate[0]=role,Cv,Profilepicture,Careers,Jobtypes,Salaryrange,Disability,Education,Workexperience&populate[1]=Userskill.Skill&populate[2]=Usercareer.Career`,
					{
						headers: {
							Authorization: `Bearer ${token}`
						}
					}
				)
				.then((resp) => {
					setUser({
						user: {
							...resp.data,
							Careers: resp.data.Careers?.map(({ id }) => id),
							Jobtypes: resp.data.Jobtypes?.map(({ id }) => id)
						},
						token
					})
					callback()
				})
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
		})
}

export const uploadFile = ({ file, fileFieldName, callback, errorFunction }) => {
	const token = getUser().token
	const userId = getUser().user.id

	const formData = new FormData()
	formData.append('files', file)
	formData.append('ref', 'plugin::users-permissions.user')
	formData.append('refId', userId)
	formData.append('field', fileFieldName)

	axios
		.post(`${process.env.GATSBY_API_URL}/upload`, formData, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'multipart/form-data'
			}
		})
		.then((response) => {
			axios
				.get(
					`${process.env.GATSBY_API_URL}/users/me?populate=role,Cv,Profilepicture,Careers,Jobtypes,Salaryrange,Disability,Education,Workexperience,Userskill,Usercareer,Userskill.Skill,Usercareer.Career`,
					{
						headers: {
							Authorization: `Bearer ${token}`,
							'Content-Type': 'multipart/form-data'
						}
					}
				)
				.then((response) => {
					setUser({
						user: {
							...response.data,
							Careers: response.data.Careers?.map(({ id }) => id),
							Jobtypes: response.data.Jobtypes?.map(({ id }) => id)
						},
						token
					})
					callback()
				})
				.catch((error) => {
					console.log('An error occurred:', error)
					console.log('message', error.message)
					console.log('response', error.response)
					errorFunction(error.response.data.message[0].messages[0])
				})
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
			errorFunction(error.response.data?.message[0].messages[0])
		})
}

// a call which returns more fields, to build the CV for instance
export const getUserFromStrapi = ({ id }, callback, errorFunction) => {
	const token = getUser().token
	axios
		.get(`${process.env.GATSBY_API_URL}/users/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'multipart/form-data'
			}
		})
		.then((response) => {
			callback(response)
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
			errorFunction(error.response.data.message[0].messages[0])
		})
}

// a call which returns only the fields for the list
export const getUsers = (
	{
		limit,
		start,
		lastname,
		email,
		careerId,
		employmentStatus,
		gender,
		description,
		qualification_in,
		experience_in,
		salaryrange_in,
		disability_in
	},
	callback,
	errorFunction
) => {
	const token = getUser().token

	const headers = {
		Authorization: `Bearer ${token}`,
		'Content-Type': 'multipart/form-data'
	}

	let requestString = `${process.env.GATSBY_API_URL}/users?populate=*&limit=${limit}&start=${start}&confirmed=true`
	if (lastname != null) {
		requestString += `&lastname=${lastname}`
	}
	if (gender != null) {
		requestString += `&gender=${gender}`
	}
	if (email != null) {
		requestString += `&email=${email}`
	}
	if (employmentStatus != null) {
		requestString += `&employmentStatus=${employmentStatus}`
	}
	if (description != null) {
		requestString += `&description=${description}`
	}
	if (qualification_in != null) {
		requestString += `&qualification_in=${qualification_in}`
	}
	if (experience_in != null) {
		requestString += `&experience_in=${experience_in}`
	}
	if (salaryrange_in != null) {
		requestString += `&salaryrange_in=${salaryrange_in}`
	}
	if (disability_in != null) {
		requestString += `&disability_in=${disability_in}`
	}

	if (careerId != null) {
		requestString += `&careerId=${careerId}`
	}
	axios
		.get(requestString, { headers })
		.then((response) => {
			callback(response)
		})
		.catch((errors) => {
			console.log('An error occurred:', errors)
			errorFunction(errors)
		})
}

export const sendEmail = ({ to, from, replyTo, subject, text, html }, callback, errorFunction) => {
	const token = getUser().token

	const headers = {
		Authorization: `Bearer ${token}`
	}

	axios
		.post(
			`${process.env.GATSBY_API_URL}/email`,
			{
				to,
				from,
				replyTo,
				subject,
				text,
				html
			},
			{
				headers
			}
		)
		.then((response) => {
			callback()
		})
		.catch((error) => {
			console.log('An error occurred:', error)
			console.log('message', error.message)
			console.log('response', error.response)
			errorFunction(error.response.data.message[0].messages[0])
		})
}
